import React, { useContext, useEffect } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import { DataContext } from '../../context/DataContext';
import { otroSeguroDefault } from '../../data/data';

import { aceptOtrosSeguros, ley540Text } from '../../data/texts';
import { getUUID } from '../../utils/helpers';

import Input from '../controls/Input';
import SwitchButton from '../controls/SwitchButton';

const Step5 = () => {

    const { poliza, setPoliza, changeHandler } = useContext(DataContext);

    const toolTipText = "</div><p class='tooltip-text'>Indicar si tiene otros seguros de vida y/o accidentes</p>";

    useEffect(() => {
        ReactTooltip.rebuild();

    }, [0]);

    const addOtroSeguro = () => {
        setPoliza({ ...poliza, otherInsuresData: [...poliza.otherInsuresData, { ...otroSeguroDefault, key: getUUID() }] });
    }

    const handleClick = (otroSeguro, e) => {

        const { key } = otroSeguro;
        /// let xparentesco = '';

        // if (e.target.name = 'parentesco' && e.target.selectedIndex >= 0) {
        //     xparentesco = e.target.options[e.target.selectedIndex].text;
        // }

        setPoliza({
            ...poliza,
            otherInsuresData: [
                ...poliza.otherInsuresData.filter(x => x.key != key),
                {
                    ...otroSeguro,
                    [e.target.name]: e.target.value
                }
            ]
        })

    }

    const deleteOtroSeguro = otroSeguro => {

        const { key } = otroSeguro;

        setPoliza({
            ...poliza,
            otherInsuresData: [
                ...poliza.otherInsuresData.filter(x => x.key != key)
            ]
        });

    }

    const visible = poliza.otherInsures === true;

    const visibleInput = visible ? 'sg-input-visible' : 'sg-input-hidden';

    useEffect(() => {

        if (poliza.otherInsuresData?.length === 0 && visible) 
            setPoliza({ ...poliza, otherInsuresData: [...poliza.otherInsuresData, { ...otroSeguroDefault, key: getUUID() }] });        

        if(!visible){
            setPoliza({ ...poliza, otherInsuresData: [] });
        }       

    }, [poliza.otherInsures]);

    return (
        <>

            <div className="reponsive">
                <div className="reponsive-width-6">
                    <div className='box-pl2-pr2'>
                        <SwitchButton label="Tenes otros seguros" value={poliza.otherInsures} onClick={value => setPoliza({ ...poliza, otherInsures: value })} >
                            <FaInfoCircle color="#E1E1E1" data-tip={toolTipText} data-html={true} />
                        </SwitchButton>
                    </div>
                </div>

            </div>
            {
                poliza.otherInsuresData.map((data, index) => {

                    const { companyName, amount, coverages } = data;

                    return <div className='new-div'>
                        <div className="reponsive" key={index}>
                            <div className='reponsive-width-5'>
                                <div className='box-pl2-pr2'>

                                    <Input required={poliza.otherInsures}
                                        label='¿Con qué compañia?' field='companyName' value={companyName}
                                        onChange={e => handleClick(data, e)} 
                                        cssClassLabel='fs-label-13'/>
                                </div>
                            </div>
                            <div className='reponsive-width-2'>
                                <div className='box-pl2-pr2'>
                                    <Input required={poliza.otherInsures} label='Suma asegurada' type='number' placeholder='$0.00' field='amount' value={amount} onChange={e => handleClick(data, e)} cssClassLabel='fs-label-13' classNameInput='w100' />
                                </div>
                            </div>
                            <div className='reponsive-width-3'>
                                <div className='box-pl2-pr2'>
                                    <Input type='textarea' required={poliza.otherInsures} label='Coberturas amparadas' field='coverages' value={coverages} onChange={e => handleClick(data, e)} placeholder='Mencionar las coberturas que tienes en tu poliza de vida y/o accidente' classNameInput='cp' cssClassLabel='fs-label-13'/>
                                </div>
                            </div>
                            <div className='reponsive-width-1 step-container-pt-15'>
                                <button className="btn-delete btn-delete-danger" onClick={() => deleteOtroSeguro(data)}>-</button>
                            </div>

                        </div>
                        <br />
                    </div>
                })
            }
            {
                poliza.otherInsuresData.length > 0 &&
                <div className="reponsive">
                    <div className='reponsive-width-12'>
                        <div className={`box-pl2-pr2 step-container-pt-15 ${visibleInput}`} style={{display: 'flex'}}>
                            <button onClick={addOtroSeguro} data-html={true} data-tip='<p class="tooltip-text">Agregar otra compañia</p>' className="control-button-btn btn-sg-primary">+</button>
                            <div className='tag-text'>Marque el signo más si desea agregar más de uno </div>
                        </div>
                    </div>
                </div>
            }
            <div className='new-div'>
                <div className="reponsive">
                    <div className="reponsive-width-12">
                        <p className="step-title">{aceptOtrosSeguros(poliza)}</p>
                    </div>
                    <div className="reponsive-width-12">
                        <p className="step-title"><b>{ley540Text}</b></p>
                    </div>
                </div>
                <div className="reponsive">
                    <div className="reponsive-width-6">
                        <SwitchButton label="" visible value={poliza.clausulaArbitraje} onClick={value => setPoliza({ ...poliza, clausulaArbitraje: value })} />
                    </div>
                </div>
            </div>
            <ReactTooltip className='tooltip-os' />
        </>
    );
}

export default Step5;
